import { MCP_TOKEN_PREFIX } from '@basehub/data/db/schema'
import { API_TOKEN_PREFIX } from '@basehub/shared-constants'

export const pkCloak = API_TOKEN_PREFIX + '****'
export const mcpTokenCloack = `${MCP_TOKEN_PREFIX}****`

/**
 * replaces pkCloak with pk if it's copied fully
 * keeps the rest of the data untouched
 */
export const handleCopyPkCloak = (
  e: React.ClipboardEvent<HTMLElement>,
  pk: string,
  _pkCloack = pkCloak
) => {
  const selection = document.getSelection()
  if (!selection) return // do nothing
  e.preventDefault()
  e.clipboardData.setData(
    'text/plain',
    selection.toString().replace(_pkCloack, pk)
  )
}
